export class VideoConfig {
  /// 直播开始时间
  // 8点
  // static statusTimer = 1604232000000;
  // 正式 17: 50;
  static statusTimer = 1604231400000;
  // 直播中 21：00:11
  static liveendTimer = 1604235611000;
  // 直播完 21：10：11
  static endTimer = 1604236211000;

  // 直播中
  // static statusTimer = 1604222300000;
  // static liveendTimer = 1604225900000;
  // static endTimer = 1604226500000;

  /// 直播完
  // static statusTimer = 1604050200000;
  // static liveendTimer = 1604054411000;
  // static endTimer = 1604055011000;

  /// 每秒的时间戳
  static minutesTimestamp = 1000;
}
